import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import FormModal from 'components/shared/modal/FormModal';
import Button from 'components/shared/button/Button';
import uploadSvg from 'images/upload.svg';
import { getLastTokenFromUrl } from 'services/utils/text-util';
import removeIconPng from 'images/remove.png';
import './UploadFilesModal.css';

class UploadFilesModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
    };
  }

  getArrayAttribute = (attr) => {
    const { form } = this.props;
    if (form && form[attr] && form[attr].length > 0) {
      return form[attr];
    }
    return [];
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state.documents);
  };

  setDocuments = (files) => {
    const docs = this.state.documents;
    files.forEach(function (val) {
      docs.push({ file: val, name: val.name });
    });

    this.setState({ documents: docs });
  };

  removeDocument = (fileName) => {
    const { documents } = this.state;
    var docs = documents.filter((document) => document.name !== fileName);
    this.setState({ documents: docs });
  };

  render() {
    const { showModal, onClose } = this.props;
    const { documents } = this.state;

    return (
      showModal && (
        <FormModal show={showModal} onClose={onClose} title="Upload Files">
          <Dropzone
            className="dropzone-container"
            multiple={true}
            onDrop={(files) => this.setDocuments(files)}
          >
            <span>Drag &amp; Drop or Browse Files</span>
            <img src={uploadSvg} alt="upload" />
          </Dropzone>
          <div className="files-viewer">
            <ul>
              {' '}
              {this.state.documents.map((data, index) => {
                return (
                  !data.removed && (
                    <li key={index}>
                      <div>
                        {data.file !== null
                          ? data.file.name
                          : getLastTokenFromUrl(
                              data.document.document.url,
                              'unknown'
                            )}
                      </div>
                      <div>
                        <img
                          src={removeIconPng}
                          onClick={() => this.removeDocument(data.file.name)}
                          alt="remove"
                        />
                      </div>
                    </li>
                  )
                );
              })}{' '}
            </ul>
          </div>
          <div className="buttons-container">
            <Button
              disabled={documents.length === 0}
              className="button-orange"
              label="Upload"
              onClick={this.handleSubmit}
            />
          </div>
        </FormModal>
      )
    );
  }
}

export default connect()(UploadFilesModal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-documentation/UploadFilesModal.js